<template>
  <div class="class-recommend">
    <div class="white-container">
      <el-form class="search-bar" :inline="true" size="small">
        <el-form-item>
          <el-autocomplete v-model="classname" class="autocomplete-input" :fetch-suggestions="querySearch" placeholder="输入课程名称" :trigger-on-focus="false" @select="handleSelect">
            <template slot="prepend">
              <i class="el-icon-search" />
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
        <BannerConfig v-for="(banner,index) in bannerList" :key="index" prop="bannerList" save-path="" :config="banner" :show-upload-image="false" :index="index" need-remove @updateConfig="updateConfig($event, index)" @remove="remove(index)" />
        <div class="flex btns" style="justify-content:center;margin-top:50px;">
          <el-button type="primary" size="small" @click="submit">保存</el-button>
        </div>
      </el-form>
    </div>
  </div>

</template>
<script>
import BannerConfig from '@/components/BannerConfig';

export default {
  components: { BannerConfig },
  data() {
    return {
      classname: '',
      selectItem: null,
      bannerList: [],
    };
  },
  created() {
    this.postCourseList();
  },
  methods: {
    postCourseList() {
      this.$Api.mpConfiguration.postCourseList().then(res => {
        this.bannerList = res.reduce((init, item) => {
          init.push({
            id: item.id,
            imageUrl: item.coverImage.courseDetailsPageHeader,
            linkUrl: item.title,
          });
          return init;
        }, []);
      });
    },
    submit() {
      if (this.bannerList.length < 3 || this.bannerList.length > 5) {
        this.$message.error('添加课程不少于3个，不多于5个');
        return false;
      }
      const params = this.bannerList.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
      this.$Api.mpConfiguration.postCourseSave(params).then(res => {
        this.$message.success('保存成功');
      });
    },
    updateConfig(config, index) {
      this.form.bannerList[index] = config;
    },
    querySearch(queryString, cb) {
      this.$Api.mpConfiguration.getCourseSearch(queryString).then(res => {
        cb(res.map(item => {
          item.value = item.title;
          return item;
        }));
      });
    },
    handleSelect(item) {
      this.selectItem = item;
    },
    add() {
      if (!this.selectItem) {
        this.$message.error('请选择添加课程');
        return false;
      }
      if (this.bannerList.some(item => item.id === this.selectItem.id)) {
        this.$message.error('该课程已经添加，请勿重复！');
        return false;
      }
      this.selectItem && this.bannerList.push({
        id: this.selectItem.id,
        imageUrl: this.selectItem.coverImage.courseDetailsPageHeader,
        linkUrl: this.selectItem.title,
      });
    },
    remove(index) {
      this.bannerList.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.autocomplete-input {
  .el-input-group__prepend {
    padding: 0 8.5px;
    background-color: #fff;
  }
  .el-input__inner {
    border-left: 0px;
    &:focus {
      border-left: 1px solid #1c1c1c;
    }
  }
}
</style>
